import React from 'react';
import { Events, scroller } from 'react-scroll';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeIsCategoryFocusEnabled,
    changeIsSummaryOpened,
    changeRoom,
    setUnfoldedCategory,
} from '../../model/configuratorSlice';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const RoomsMenu = () => {
  const rooms = useSelector(state => state.configurator.rooms);
  const currentRoom = useSelector(state => state.configurator.currentRoom);
  const isSummaryOpened = useSelector(state => state.configurator.isSummaryOpened);
  const dispatch = useDispatch();

  const onSummaryOpened = () => {
    dispatch(changeIsSummaryOpened(true));
  };

  const scrollToRoom = (roomId) => {
    dispatch(changeRoom(roomId));
    dispatch(changeIsSummaryOpened(false));

    Events.scrollEvent.register('end', () => {
      dispatch(changeIsCategoryFocusEnabled(true));
      dispatch(setUnfoldedCategory(''));
      Events.scrollEvent.remove('end');
    });

    dispatch(changeIsCategoryFocusEnabled(false));


    scroller.scrollTo(roomId,
      {
        containerId: 'container-rooms',
        duration: 1200,
        delay: 200,
        smooth: 'easeInOut',
      });
  };

  return (
    <div className="rooms-menu">
      { rooms.map((room, index) => (
        <button
          className={`room-button${currentRoom !== null 
          && !isSummaryOpened && currentRoom.id === room.id ? ' active' : ''}`}
          type="button"
          onClick={() => scrollToRoom(room.id)}
        >
          {TranslationUtility.GetFormattedMessageForRoomName(room)}
          <div
            className={`underline${currentRoom !== null
            && !isSummaryOpened && currentRoom.id === room.id ? ' active' : ''}`}
          />
        </button>
      ))}
      <button
        type="button"
        className={`room-button${isSummaryOpened ? ' active' : ''}`}
        onClick={onSummaryOpened}
      >
        {TranslationUtility.GetFormattedMessageForUI('ui-rooms-menu-summary', 'Resumen')}
        <div
          className={`underline${isSummaryOpened ? ' active' : ''}`}
        />
      </button>
    </div>
  );
};

export default RoomsMenu;
